export default __webpack_public_path__ + "static/media/erik-mclean-YW0d_dWI6LI-unsplash.1decb89f.jpg";